import { render, staticRenderFns } from "./customButton.vue?vue&type=template&id=29b4b0fc&scoped=true"
import script from "./customButton.vue?vue&type=script&lang=js"
export * from "./customButton.vue?vue&type=script&lang=js"
import style0 from "./customButton.vue?vue&type=style&index=0&id=29b4b0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b4b0fc",
  null
  
)

export default component.exports